import React, { Component } from 'react';

import {
    withRouter
} from 'react-router-dom';
import {
    Text,
    Button,
    BlockStack,
    Icon,
    Card,
    ButtonGroup,
    ActionList,
    Popover,
    ProgressBar,
    TextField,
    Select,

} from '@shopify/polaris';
import { LanguageIcon, SearchIcon } from "@shopify/polaris-icons";
import './index.scss';
import {
    reqUpdateLanguage,
    reqSaveSwitchState,
    reqGetSEOCheckerData,
    reqUpdGuideSteps,
    reqGetWebsiteSyncStatus,
    reqGetAnalyzeBusiness,
    reqUpdAnalyzeBusiness,

} from '../../../api';
import { connect } from 'react-redux'
import { setSaveSwitchData, changeLanguageInfo, setLangState, setSaveGuideSwitchData } from '../../../redux/actions/getAppPublicData';
import { store } from '../../../redux/store';
import utils from '../../../utils/utils';
import cloneDeep from 'lodash-es/cloneDeep';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
import UserTrialDicountModal from "../../../components/UserTrialDicountModal";
import CircularGauge from '../../../components/CircularGauge';
import Countrys from '../../../utils/country';
import TagTextInput from './components/TagTextInput';
// 翻译
import Language from '../../../i18n/Language';
import { setPageData } from '../../../redux/actions/getAppPageData';
import SkeltonLoading from '../../../components/SkeltonLoading';
import { AiLanguageArr } from '../../../utils/LanguageList';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import { cwreport } from '../../../cw_center/cw-report';
import { transportReport } from '../../../cw_center/global';
const t = Language;
// 假进度
const fakeSteps = [
    { delay: 1000, value: 5 },
    { delay: 10000, value: 35 },
    { delay: 20000, value: 65 },
];

// 保存定时器
let SEOCheckArr = [];
let AnalysisStatusArr = [];
class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepIndex: 0, // 页面索引
            stepChildIndex: 0, // 子页面索引
            modeItem: 0,    // 模式选择
            LanguageVal: 'en',
            isShowTrialBlock: false,
            language: this.props.language,
            isComboUser: this.props.isComboUser,
            languageActive: false,
            fixShow: 0,
            ranksShow: 0,
            userName: '👋',
            completedVal: 0,
            BrandNameValue: '',
            aiLang: 'en',
            currents: {},
            countryValue: '',
            countryView: [],
            countryLens: 0,
            nationState: false,
            countryAll: [],
            cpage: 1,
            csize: 20,
            locationId: 2840,
            SEOScore: 0,
            updGuideLoading: false,
            isJump: 0,
            loadingPage: true,
            PrimaryProduct: [],
            KeyProductAttributes: [],
            TargetPersona: [],
            fristChange: true,
            issuesNum: 0,

            // 新版本字段 1027
            // Speed加速 分类
            SpeedOptTags: {
                Strong: [],
                Slight: [],
            },
            SpeedOptCompare: {
                title: {
                    "site_speed_up": "Google pagespeed score",
                    // "alt_attribute": "Image alt texts",
                    "image_optimize": "Images uncompressed",
                    "amp": "AMP",
                },
                subdesc: {
                    "site_speed_up": "As a direct ranking factor, the speed of your website influences how it will rank on Google. Page speed can also impact bounce rate and session time on your site, which also affects SEO",
                    // "alt_attribute": "Image alt texts are descriptive texts added to images on websites, primarily to provide context for screen readers and improve accessibility, as well as to enhance SEO by helping search engines understand the image content.",
                    "image_optimize": "Reduce the file size of your images as much as possible without sacrificing quality, and your page load times will be short.",
                    "amp": "AMP can help improve your website speed on mobile devices, which can boost your mobile search rankings.",
                },
                desc: {
                    wrong: {
                        "site_speed_up": "Your store's speed score is slower than average!",
                        // "alt_attribute": "{{v1}} images: Image alt texts missing",
                        "image_optimize": "{{v1}} images: Uncompressed",
                        "amp": "AMP is not enabled on your homepage and product pages.",
                        "amp_home": "AMP is not enabled on your homepage.",
                        "amp_product": "AMP is not enabled on your product pages.",
                    },
                    right: {
                        "site_speed_up": "Your store's speed score is greater than average",
                        // "alt_attribute": "All your images have alt text.",
                        "image_optimize": "All your images have been compressed.",
                        "amp": "AMP is enabled on the product page and homepage.",
                    }
                }
            },
            // Content Optimization 分类
            ContentOptTags: {
                Strong: [],
                Slight: [],
            },
            ContentOptCompare: {
                title: {
                    "headings_miss": "H1 missing",
                    "headings_beyond": "Multiple H1 tags found",
                    "onpage_seo": "Page SEO score",
                    "onpage_seo_important": "Page SEO score",
                    "onpage_seo_improve": "Page SEO score",
                    "alt_attribute": "Image alt texts",
                    "title_miss": "Meta title missing",
                    "title_beyond": "Multiple Meta title found",
                    "title_length": "Meta title length",
                    "desc_miss": "Meta description missing",
                    "desc_beyond": "Multiple Meta description found",
                    "desc_length": "Meta description length",
                },
                subdesc: {
                    "headings_miss": "The H1 tag defines the primary heading of a webpage, helping with SEO and content organization.",
                    "headings_beyond": "The H1 tag defines the primary heading of a webpage, helping with SEO and content organization.",
                    "onpage_seo": "The website SEO score helps assess a site's optimization level, guiding improvements for better search engine rankings.",
                    "onpage_seo_important": "The website SEO score helps assess a site's optimization level, guiding improvements for better search engine rankings.",
                    "onpage_seo_improve": "The website SEO score helps assess a site's optimization level, guiding improvements for better search engine rankings.",
                    "alt_attribute": "Image alt texts are descriptive texts added to images on websites, primarily to provide context for screen readers and improve accessibility, as well as to enhance SEO by helping search engines understand the image content.",
                    "title_miss": "The meta title is the clickable headline that appears in search engine results, helping with SEO and attracting users to visit the page.",
                    "title_beyond": "The meta title is the clickable headline that appears in search engine results, helping with SEO and attracting users to visit the page.",
                    "title_length": "Meta title length should be between 50-70 characters to ensure better display on Google search page.",
                    "desc_miss": "The meta description is a brief summary of a webpage's content, shown in search results to encourage users to click on the link.",
                    "desc_beyond": "The meta description is a brief summary of a webpage's content, shown in search results to encourage users to click on the link.",
                    "desc_length": "Meta description length should be between 120-160 characters to ensure better display on Google search page",
                },
                desc: {
                    wrong: {
                        "headings_miss": "{{v1}} pages: Missing H1",
                        "headings_beyond": "{{v1}} pages: Multiple H1 tags.",
                        "onpage_seo_important": "{{v1}} pages: SEO score is too low.",
                        "onpage_seo_improve": "{{v1}} pages: SEO score need to improve.",
                        "alt_attribute": "{{v1}} images: Image alt texts missing",
                        "title_miss": "{{v1}} pages: Meta title missing.",
                        "title_beyond": "{{v1}} pages: Multiple Meta title.",
                        "title_length": "{{v1}} pages: Meta title length needs optimization.",
                        "desc_miss": "{{v1}} pages: Meta description missing.",
                        "desc_beyond": "{{v1}} pages: Multiple Meta description.",
                        "desc_length": "{{v1}} pages: Meta description length needs optimization.",
                    },
                    right: {
                        "headings_miss": "All your pages have H1 tag.",
                        "headings_beyond": "All your pages only have one H1 tag.",
                        "onpage_seo": "All your page content complies with SEO score guidelines.",
                        "alt_attribute": "All your images have alt text.",
                        "title_miss": "All your pages have Meta title.",
                        "title_beyond": "All your pages only have one Meta title.",
                        "title_length": "All the Meta title have a good length.",
                        "desc_miss": "All your pages have Meta description.",
                        "desc_beyond": "All your pages only have one Meta description.",
                        "desc_length": "All the Meta description have a good length.",
                    },
                }
            },
            // GEO 分类
            GEOTags: {
                Strong: [],
                Slight: [],
            },
            GEOCompare: {
                title: {
                    "json_ld": "Structured Data",
                    "llms_txt": "llms.txt",
                },
                subdesc: {
                    "json_ld": "Enable structured data types to help search engines and AI platforms better understand your store content.",
                    "llms_txt": "llms.txt helps AI systems understand your site structure and content, improving visibility in AI-powered search and assistants.",
                },
                desc: {
                    wrong: {
                        "json_ld": "{{v1}} structured data types are not enabled.",
                        "llms_txt": "llms.txt not optimized",
                    },
                    right: {
                        "json_ld": "All structured data types are enabled.",
                        "llms_txt": "llms.txt optimized",
                    }
                }
            },

            // Technical SEO 分类
            TechnicalSEOTags: {
                Strong: [],
                Slight: [],
            },
            TechnicalSEOCompare: {
                title: {
                    "robots": "Robot.txt file",
                    "noindex": "'no index' page",
                    "nofollow": "'no follow' link",
                    "underscores_in_the_urls": "URL underscores",
                    "canonical": "Canonical tag",
                    "http_https": "Http to Https",
                    "www_nowww": "non-www to www",
                    "is_https": "Website security",
                    "mixed_content": "Mixed content errors",
                    "domain_blocked": "Blacklist",
                    "favicon": "Favicon",
                    "html_sitemap": "HTML Sitemap",
                    "broken_links": "URL broken links",
                },
                subdesc: {
                    "robots": "It tells search engines which pages to crawl or avoid, helping control the indexing of your site's content.",
                    "noindex": [
                        "When using noindex on a page, it tells search engines not to index that page in search results. This means:",
                        "The page will not appear in search engine results, leading to a loss of organic traffic.",
                        "If the page contains important content or links to other important pages, using noindex will make these contents invisible to search engines, which can lower the overall ranking of the site.",
                    ],
                    "nofollow": [
                        "When using nofollow, search engines will ignore the links on the page and will not pass link authority (i.e., PageRank). This could lead to:",
                        "Some links on the site (even internal links) not passing authority to the target pages, which affects their rankings.",
                        "If applied to many pages, it could limit the overall link value of the site, affecting how search engines evaluate the entire site.",
                    ],
                    "underscores_in_the_urls": "Using underscores can hurt SEO, search engines prefer hyphens to separate words.",
                    "canonical": "Helps prevent duplicate content issues by specifying the preferred version of a page for indexing.",
                    "http_https": "Switching from HTTP to HTTPS improves security and can boost your SEO rankings.",
                    "www_nowww": "Ensures the website uses a consistent URL format, either with or without \"www\", which benefits SEO.",
                    "is_https": "SSL encryption secures data between the user and the website, improving security and boosting SEO.",
                    "mixed_content": "Occurs when a secure HTTPS page contains non-secure HTTP content, which can harm security and SEO.",
                    "domain_blocked": "A list of sites or IPs that are blocked or penalized, usually due to harmful content or behavior, affecting SEO and trust.",
                    "favicon": "A small icon displayed in the browser tab, improving brand recognition and user experience.",
                    "html_sitemap": "HTML sitemap is a page on a website that lists all the important pages, helping users and search engines navigate the site more easily.",
                    "broken_links": "URL broken links are links on a webpage that lead to non-existent or unavailable pages, negatively impacting user experience and SEO.",
                },
                desc: {
                    wrong: {
                        "robots": "Your store does not have Robot.txt.",
                        "noindex": "Some pages are set to not be indexed by search engines.",
                        "nofollow": "Some links are set to not be followed by search engines.",
                        "underscores_in_the_urls": "The URLs contain underscores.",
                        "canonical": "The canonical tag not found.",
                        "http_https": "The http to https not redirected.",
                        "www_nowww": "non-www to www not redirected.",
                        "is_https": "Website is not SSL secured.",
                        "mixed_content": "Mix content issues found.",
                        "domain_blocked": "Website domain is blacklisted.",
                        "favicon": "Favicon missing.",
                        "html_sitemap": "HTML is not enabled on your page.",
                        "broken_links": "{{v1}} broken links: need to be redirected.",
                    },
                    right: {
                        "robots": "Your store is friendly with robots.",
                        "noindex": "All pages can be indexed.",
                        "nofollow": "All links can be followed.",
                        "underscores_in_the_urls": "The URLs has not underscores.",
                        "canonical": "The canonical tag has been implemented appropriately.",
                        "http_https": "The http to https redirected.",
                        "www_nowww": "non-www to www redirected.",
                        "is_https": "Website is SSL secured.",
                        "mixed_content": "No mixed content errors found.",
                        "domain_blocked": "Website domain is not blacklisted.",
                        "favicon": "Your store have favicon.",
                        "html_sitemap": "HTML is enabled on your page.",
                        "broken_links": "All your links are accessible.",
                    }
                }
            },
            // 源对象
            checkItemData: {
                "Speed Optimization": {
                    status: -1,
                    nums: 0,
                    subtitle: '-',
                    issue: [],
                },
                "Content Optimization": {
                    status: -1,
                    nums: 0,
                    subtitle: '-',
                    issue: [],
                },
                "GEO": {
                    status: -1,
                    nums: 0,
                    subtitle: '-',
                    issue: [],
                },
                "Technical SEO": {
                    status: -1,
                    nums: 0,
                    subtitle: '-',
                    issue: []
                },
            },
            CriticalIssueNum: 0,
            ImproveIssueNum: 0,
            GoodResIssueNum: 0,
        }
        this.fakeTimers = []; // 保存定时器
    }

    componentDidMount() {
        // posthog埋点 引导页
        this.cwreportGuideView(1);

        // 初始化国家数据
        let { cpage, csize } = this.state;
        this.setState({
            countryAll: Countrys,
            currents: Countrys[0],
            countryView: Countrys.slice((cpage - 1) * csize, (cpage * csize)),
            countryLens: Countrys.length,
        })

        // 监听缓存数据
        store.subscribe(() => {
            // 判断是否完成引导
            if (!(store.getState().public?.guideVerify)) return;
            const guideData = store.getState().public.publicInit?.guide_steps;
            let { shopOwner, Language } = store.getState().public;
            this.setState({
                userName: `${shopOwner} 👋` || '👋',
                LanguageVal: Language,
                loadingPage: !Boolean(guideData)
            })

            let guideStateItem = Boolean(guideData && guideData.length > 0) ? guideData.find(i => i.step_key === "select_model") : false;
            let isFinishGuide = Boolean(guideStateItem) ? guideStateItem?.is_completed === 1 : true;
            if (isFinishGuide) {
                // 跳转首页
                if (this.state.isJump === 0) {
                    // this.props.toggleToast(t("Guide completed"), false);
                    setTimeout(() => {
                        utils.routeJump(this, "/dashboard");
                    }, 1500)
                }
                this.setState({
                    isJump: 1,
                })
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.stepIndex !== this.state.stepIndex) {
            this.cwreportGuideView(this.state.stepIndex + 1);
        }
    }

    componentWillUnmount() {
        this.clearFakeTimers();
        this.clearSEOCheckArr();
        this.clearAnalysisStatusArr();
    }

    // posthog埋点 ======================================================= start
    // 浏览
    cwreportGuideView = (s_index = 1) => {
        if (window.shopify && cwreport) {
            transportReport('view_onboarding', {
                step_index: s_index,
            });
        }
    }
    // 跳过
    cwreportGuideSkip = () => {
        if (window.shopify && cwreport) {
            transportReport('skip_onboarding', {
                step_index: 3,
            });
        }
    }
    // 完成
    cwreportGuideComplete = () => {
        if (window.shopify && cwreport) {
            transportReport('finish_onboarding', {
                step_index: 3,
            });
        }
    }
    // posthog埋点 ======================================================= end

    // 获取checker数据
    getSeoCheckerData = async () => {
        const res = await reqGetSEOCheckerData();
        if (res.ack === 1) {
            this.props.getSEOCheckDataRedux({ seoData: res });
            let _res = res.data;
            if (_res.status === 0) {
                if (SEOCheckArr.length === 0) {
                    // 还未检测完成， 继续轮询
                    let timer = setInterval(() => {
                        this.getSeoCheckerData();
                    }, 5000)
                    SEOCheckArr.push(timer)
                }
            } else {
                this.setDegreeTag(_res.config, _res).then(states => {
                    setTimeout(() => {
                        if (states) {
                            this.formatCheckerData(_res, _res.config, states).then(resData => {
                                let all_list = resData;
                                let CriticalIssueNum = 0, ImproveIssueNum = 0, GoodResIssueNum = 0;
                                Object.values(all_list).forEach(n => {
                                    n.issue.forEach(i => {
                                        // 严重和待优化
                                        if (i.nums > 0 && i.degree) {
                                            if (i.degree === 1) {
                                                CriticalIssueNum += 1;
                                            } else {
                                                ImproveIssueNum += 1;
                                            }
                                        }

                                        // 单独计算完成数量
                                        if (i.nums === 0 && i.tag.indexOf("onpage_seo") === -1) {
                                            GoodResIssueNum += 1;
                                        } else {
                                            // if (Object.values(i.children).includes(0) && ["onpage_seo", "title_miss", "title_beyond", "title_length", "desc_miss", "desc_beyond", "desc_length", "alt_attribute", "headings_miss", "headings_beyond", "amp", "json_ld"].includes(i.tag)) {
                                            //     GoodResIssueNum += 1;
                                            // }
                                        }
                                    })
                                })

                                this.setState({
                                    completedVal: 100,
                                    stepIndex: 1,
                                    stepChildIndex: 0,
                                    SEOScore: res.data.score,
                                    issuesNum: res.data.issues,
                                    CriticalIssueNum,
                                    ImproveIssueNum,
                                    GoodResIssueNum,
                                }, () => {
                                    this.clearSEOCheckArr();
                                })

                            })
                        }
                    })
                })
            }
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 设置tag严重程度
    setDegreeTag = async (configs, data) => {
        let clist = cloneDeep(configs);
        let cdata = cloneDeep(data);
        let singleTag = ["image_optimize", "alt_attribute", "broken_links", "json_ld"]; // 单字段
        clist.forEach(item => {
            if (item['category_field'] === "title_tag") {
                item['tagsField'] = item['param_field'] === "pageUnfilled" ? `title_unfilled_page` : `title_${item['param_field']}`;
            } else if (item['category_field'] === "meta_description") {
                item['tagsField'] = item['param_field'] === "pageUnfilled" ? `desc_unfilled_page` : `desc_${item['param_field']}`;
            } else if (singleTag.includes(item['category_field'])) {
                item['tagsField'] = `${item['category_field']}`;
            } else if (item['category_field'] === "onpage_seo") {
                item['tagsField'] = item['param_field'] === "need_improve" ? `${item['category_field']}_improve` : `${item['category_field']}_important`;
            } else if (['site_speed_up', 'amp_home', 'amp_product', 'html_sitemap', 'llms_txt', 'mixed_content', 'favicon', 'underscores_in_the_urls', 'robots', 'noindex', 'nofollow', 'canonical', 'http_https', 'www_nowww', 'is_https', 'domain_blocked'].includes(item['category_field'])) {
                item['tagsField'] = `${item['category_field']}`;
            } else {
                item['tagsField'] = `${item['category_field']}_${item['param_field']}`;
            }
        })

        // 加速分类
        let speedOpt = ["site_speed_up", "image_optimize", "amp", "amp_home", "amp_product"];
        let speedOptStrong = [], speedOptSlight = [];

        // Content Optimization 分类
        let contentOpt = ["headings_miss", "headings_beyond", "onpage_seo_important", "onpage_seo_improve"];
        let contentOptFields = ["alt_attribute", "title_tag", "meta_description"];
        let contentOptStrong = [], contentOptSlight = [];

        // GEO 分类
        let GeoFields = ["json_ld", "llms_txt"];
        let GeoStrong = [], GeoSlight = [];

        // Technical SEO 分类
        let TechnicalSEO = ["robots", "noindex", "nofollow", "underscores_in_the_urls", "canonical", "http_https", "www_nowww", "is_https", "mixed_content", "domain_blocked", "favicon", "broken_links", "html_sitemap"];
        let TechnicalSEOStrong = [], TechnicalSEOSlight = [];

        // 获取等级严重列表单独操作
        let titleTagHight = clist.filter(i => i.category_field === "title_tag" && i.level === 2);
        let titleDescHight = clist.filter(i => i.category_field === "meta_description" && i.level === 2);
        let titleTagPage = clist.filter(i => i.category_field === "title_tag" && i.param_field === "pageUnfilled");
        let titleDescPage = clist.filter(i => i.category_field === "meta_description" && i.param_field === "pageUnfilled");

        clist.forEach(tags => {
            // Speed加速 分类
            if (speedOpt.includes(tags['category_field'])) {
                if (tags['level'] === 2) {
                    speedOptStrong.push(tags['tagsField'])
                }
                if (tags['level'] === 1) {
                    speedOptSlight.push(tags['tagsField'])
                }
            }

            // Content Optimization 分类 - headings / onpage_seo
            if (contentOpt.includes(tags['tagsField'])) {
                if (tags['level'] === 2) {
                    contentOptStrong.push(tags['tagsField'])
                }
                if (tags['level'] === 1) {
                    contentOptSlight.push(tags['tagsField'])
                }
            }

            // Content Optimization 分类 - title / desc / alt
            if (contentOptFields.includes(tags['category_field'])) {
                let SADataTag = cdata.contentOptimization?.title_tag?.content || {};
                let SADataDesc = cdata.contentOptimization?.meta_description?.content || {};
                if (tags['category_field'] === "title_tag" && Object.keys(SADataTag).length > 0) {
                    if (titleTagHight.length > 0) {
                        let tagsDegree = titleTagHight.map(i => { return i.param_field });
                        let allNums = 0;
                        tagsDegree.forEach(t => {
                            if (t !== 'pageUnfilled' && SADataTag[t]) {
                                let nums = Object.values(SADataTag[t]).reduce((a, b) => a + b);
                                allNums += nums;
                                if (nums > 0) {
                                    if (!contentOptStrong.includes(tags['category_field'])) {
                                        contentOptStrong.push(tags['category_field'])
                                    }
                                }
                            }
                        })
                        // 判断总数量
                        if ((allNums > 0 && tagsDegree.includes('unfilled') && SADataTag['unfilled'] && allNums === SADataTag['unfilled']['page'] && titleTagPage[0]?.['level'] === 1) || allNums === 0) {
                            // 如果等于page数量, 需要判断等级   
                            if (!contentOptSlight.includes(tags['category_field']) && !contentOptStrong.includes(tags['category_field'])) {
                                contentOptSlight.push(tags['category_field'])
                            }
                        } else {
                            if (!contentOptStrong.includes(tags['category_field'])) {
                                contentOptStrong.push(tags['category_field'])
                            }
                        }
                    } else {
                        if (!contentOptSlight.includes(tags['category_field']) && !contentOptStrong.includes(tags['category_field'])) {
                            contentOptSlight.push(tags['category_field'])
                        }
                    }
                } else if (tags['category_field'] === "meta_description" && Object.keys(SADataDesc).length > 0) {
                    if (titleDescHight.length > 0) {
                        let tagsDegree = titleDescHight.map(i => { return i.param_field });
                        let allNums = 0;
                        tagsDegree.forEach(t => {
                            if (SADataDesc[t]) {
                                let nums = Object.values(SADataDesc[t]).reduce((a, b) => a + b);
                                allNums += nums;
                                if (nums > 0) {
                                    if (!contentOptStrong.includes(tags['category_field'])) {
                                        contentOptStrong.push(tags['category_field'])
                                    }
                                }
                            }
                        })
                        // 判断总数量
                        if ((allNums > 0 && tagsDegree.includes('unfilled') && SADataDesc['unfilled'] && allNums === SADataDesc['unfilled']['page'] && titleDescPage[0]?.['level'] === 1) || allNums === 0) {
                            // 如果等于page数量, 需要判断等级   
                            if (!contentOptSlight.includes(tags['category_field']) && !contentOptStrong.includes(tags['category_field'])) {
                                contentOptSlight.push(tags['category_field'])
                            }
                        } else {
                            if (!contentOptStrong.includes(tags['category_field'])) {
                                contentOptStrong.push(tags['category_field'])
                            }
                        }
                    } else {
                        if (!contentOptSlight.includes(tags['category_field']) && !contentOptStrong.includes(tags['category_field'])) {
                            contentOptSlight.push(tags['category_field'])
                        }
                    }
                } else if (tags['category_field'] === "alt_attribute") {
                    if (tags['level'] === 2) {
                        contentOptStrong.push(tags['tagsField'])
                    }
                    if (tags['level'] === 1 && !contentOptStrong.includes(tags['tagsField'])) {
                        contentOptSlight.push(tags['tagsField'])
                    }
                }
            }

            // GEO 分类
            if (GeoFields.includes(tags['category_field'])) {
                if (tags['level'] === 2) {
                    GeoStrong.push(tags['tagsField'])
                }
                if (tags['level'] === 1 && !GeoStrong.includes(tags['tagsField'])) {
                    GeoSlight.push(tags['tagsField'])
                }
            }

            // Technical SEO 分类
            if (TechnicalSEO.includes(tags['category_field'])) {
                if (tags['level'] === 2) {
                    TechnicalSEOStrong.push(tags['tagsField'])
                }
                if (tags['level'] === 1) {
                    TechnicalSEOSlight.push(tags['tagsField'])
                }
            }

        })
        const objData = {
            SpeedOptTags: {
                Strong: speedOptStrong,
                Slight: speedOptSlight,
            },
            ContentOptTags: {
                Strong: contentOptStrong,
                Slight: contentOptSlight,
            },
            GEOTags: {
                Strong: GeoStrong,
                Slight: GeoSlight,
            },
            TechnicalSEOTags: {
                Strong: TechnicalSEOStrong,
                Slight: TechnicalSEOSlight,
            }
        }
        this.setState(objData);

        return objData;
    }

    // 格式化数据
    formatCheckerData = async (data, resConfig, tagData) => {
        // 动态数量文案 字段
        const numTag = ["image_optimize", "alt_attribute", "headings_miss", "headings_beyond", "onpage_seo_important", "onpage_seo_improve", "title_miss", "title_beyond", "title_length", "desc_miss", "desc_beyond", "desc_length", "broken_links", "json_ld"];
        // 存在但不显示产品等子项层级 字段
        const noSonTier = ["image_optimize"];
        // 描述 & 按钮
        const descAndBtn = ["image_optimize", "broken_links"];

        let {
            checkItemData,
            SpeedOptCompare,
            ContentOptCompare,
            GEOCompare,
            TechnicalSEOCompare,

        } = this.state;
        let tagSource = Boolean(tagData) ? tagData : this.state;
        let {
            ContentOptTags,
            GEOTags,
            TechnicalSEOTags,
        } = tagSource;
        let checkItem = cloneDeep(checkItemData); // 总列表数据
        // Speed Optimization项 ------------------ 问题 
        let speedOptObj = {}, speedOptList = [];
        Object.keys(data.speedOptimization).forEach(item => {
            if (data.speedOptimization['state'] === 1) {
                if (item !== 'state' && item !== 'ignore') {
                    if (!['amp_home', 'amp_product'].includes(item)) {
                        speedOptObj[item] = data.speedOptimization[item];
                    } else {
                        // amp 判断是否合并
                        speedOptObj.amp = {
                            amp_home: data.speedOptimization.amp_home,
                            amp_product: data.speedOptimization.amp_product,
                        }
                    }
                }
            }
        })
        if (Object.keys(speedOptObj).length > 0) {
            speedOptList = Object.keys(speedOptObj).map(item => {
                let num = 0, childShow = true;
                let isHome = 0, ampChild = {}, ampIgnore = [];
                if (['image_optimize'].includes(item)) {
                    Object.values(speedOptObj[item]['content']).forEach(n => {
                        num += Number(n);
                    })
                } else if (item === 'site_speed_up') {
                    num = speedOptObj['site_speed_up']['content']['status'] === 1 ? 0 : (speedOptObj['site_speed_up']['content']['before_mb_score'] < 40 || speedOptObj['site_speed_up']['content']['before_pc_score'] < 50) ? 1 : 0;
                    childShow = false;
                } else {
                    if (item === "amp") {
                        let homeState = speedOptObj[item].amp_home.content.status;
                        let proState = speedOptObj[item].amp_product.content.status;
                        num = (homeState === 1 ? 0 : 1) + (proState === 1 ? 0 : 1);
                        isHome = homeState === 0;
                        ampChild = {
                            product: proState === 1 ? 0 : 1,
                            home: homeState === 1 ? 0 : 1,
                        }
                        childShow = true;
                        ampIgnore = [Object.keys(speedOptObj[item]['amp_product']['content']).includes('ignore') ? speedOptObj[item]['amp_product']['content'] : false, Object.keys(speedOptObj[item]['amp_home']['content']).includes('ignore') ? speedOptObj[item]['amp_home']['content'] : false]
                    } else {
                        num = speedOptObj[item]['content']['status'] === 1 ? 0 : 1;
                        childShow = false;
                    }
                }
                let speedOptArr = {
                    tag: item,
                    title: SpeedOptCompare.title[item],
                    desc: num > 0 ? (item.indexOf("amp") > -1 ? (num === 2 ? SpeedOptCompare.desc.wrong["amp"] : isHome ? SpeedOptCompare.desc.wrong["amp_home"] : SpeedOptCompare.desc.wrong["amp_product"]) : SpeedOptCompare.desc.wrong[item]) : SpeedOptCompare.desc.right[item],
                    subdesc: SpeedOptCompare.subdesc[item],
                    nums: num,
                    state: num === 0 ? true : false,
                    degree: resConfig.filter(objs => objs['category_field'] === item)[0]?.level === 2 ? 1 : 2,
                    children: ['image_optimize'].includes(item) ? speedOptObj[item]['content'] : item.indexOf('amp') > -1 ? ampChild : {},
                    childShow: childShow,
                    isIgnore: item.indexOf("amp") > -1 ? ampIgnore : typeof speedOptObj[item]['content'] !== 'object' ? false : Object.keys(speedOptObj[item]['content']).includes('ignore') ? speedOptObj[item]['content'] : false,
                    isShowNumDesc: numTag.includes(item) && num > 0 ? true : false,
                    noShowSonTier: Boolean(noSonTier.includes(item)),
                    primaryBtn: Boolean(descAndBtn.includes(item)),
                }
                if (item === "site_speed_up") {
                    speedOptArr['score'] = speedOptObj[item]['content'];
                }
                return speedOptArr
            })
            checkItem['Speed Optimization']['status'] = (speedOptList.filter(item => item.degree === 1 && item.nums > 0)).length > 0 ? 1 : (speedOptList.filter(item => item.degree === 2 && item.nums > 0)).length > 0 ? 2 : true;
            checkItem['Speed Optimization']['nums'] = this.getSums(speedOptList, 'nums') - data.speedOptimization.ignore;
            checkItem['Speed Optimization']['issue'] = this.sortList(speedOptList, 'speedOpt', tagData);
            checkItem['Speed Optimization']['subtitle'] = this.getSums(speedOptList, 'nums') !== 0 ? (this.getSums(speedOptList, 'nums') > 1 ? t("Notices detected") : t("Notice detected")) : t("All Speed Optimization items are set correctly");
        } else {
            checkItem['Speed Optimization']['status'] = true;
            checkItem['Speed Optimization']['issue'] = [];
            checkItem['Speed Optimization']['subtitle'] = t("Detecting") + '...';
        }

        // Content Optimization项 ------------------ 问题 
        let ContentOptimizationObj = {}, ContentOptimizationList = [];
        Object.keys(data.contentOptimization).forEach(item => {
            if (data.contentOptimization['state'] === 1) {
                if (item !== 'state' && item !== 'ignore') {
                    if (item === 'headings') {
                        ContentOptimizationObj['headings_miss'] = data.contentOptimization[item]['content']['miss'];
                        ContentOptimizationObj['headings_beyond'] = data.contentOptimization[item]['content']['beyond'];
                    } else if (item === 'onpage_seo') {
                        let importantData = data.contentOptimization[item]['content']['important_issues'];
                        let improveData = data.contentOptimization[item]['content']['need_improve'];
                        ContentOptimizationObj['onpage_seo_important'] = importantData;
                        ContentOptimizationObj['onpage_seo_improve'] = improveData;
                        ContentOptimizationObj['onpage_seo'] = Object.keys({ ...importantData, ...improveData }).reduce((acc, key) => {
                            acc[key] = (importantData[key] || 0) + (improveData[key] || 0);
                            return acc;
                        }, {});
                    } else if (item === 'title_tag') {
                        ContentOptimizationObj['title_miss'] = data.contentOptimization[item]['content']['miss'];
                        ContentOptimizationObj['title_beyond'] = data.contentOptimization[item]['content']['beyond'];
                        let tooLong = data.contentOptimization[item]['content']['tooLong'];
                        let tooShort = data.contentOptimization[item]['content']['tooShort'];
                        let unfilled = data.contentOptimization[item]['content']['unfilled'];
                        ContentOptimizationObj['title_length'] = Object.keys({ ...tooLong, ...tooShort, ...unfilled }).reduce((acc, key) => {
                            acc[key] = (tooLong[key] || 0) + (tooShort[key] || 0) + (unfilled[key] || 0);
                            return acc;
                        }, {});
                    } else if (item === 'meta_description') {
                        ContentOptimizationObj['desc_miss'] = data.contentOptimization[item]['content']['miss'];
                        ContentOptimizationObj['desc_beyond'] = data.contentOptimization[item]['content']['beyond'];
                        let tooLong = data.contentOptimization[item]['content']['tooLong'];
                        let tooShort = data.contentOptimization[item]['content']['tooShort'];
                        let unfilled = data.contentOptimization[item]['content']['unfilled'];
                        ContentOptimizationObj['desc_length'] = Object.keys({ ...tooLong, ...tooShort, ...unfilled }).reduce((acc, key) => {
                            acc[key] = (tooLong[key] || 0) + (tooShort[key] || 0) + (unfilled[key] || 0);
                            return acc;
                        }, {});
                    } else {
                        ContentOptimizationObj[item] = data.contentOptimization[item]['content'];
                    }
                }
            }
        })
        if (Object.keys(ContentOptimizationObj).length > 0) {
            ContentOptimizationList = Object.keys(ContentOptimizationObj).map(item => {
                let num = 0, childShow = true;
                if (item !== "onpage_seo") {
                    Object.values(ContentOptimizationObj[item]).forEach(n => {
                        num += Number(n);
                    })
                }
                let degree = item === 'headings_miss' ? (resConfig.filter(objs => objs['category_field'] === 'headings' && objs['param_name'] === "H1 Missing")[0].level === 2 ? 1 : 2) :
                    item === 'headings_beyond' ? (resConfig.filter(objs => objs['category_field'] === 'headings' && objs['param_name'] === "Multiple h1 tags found")[0].level === 2 ? 1 : 2) :
                        item === 'onpage_seo' ? 0 :
                            item === 'onpage_seo_important' ? (resConfig.filter(objs => objs['category_field'] === 'onpage_seo' && objs['param_name'] === "important issues")[0].level === 2 ? 1 : 2) :
                                item === 'onpage_seo_improve' ? (resConfig.filter(objs => objs['category_field'] === 'onpage_seo' && objs['param_name'] === "need improvements")[0].level === 2 ? 1 : 2) :
                                    ((ContentOptTags.Strong.includes("title_tag") && ["title_miss", "title_beyond", "title_length"].includes(item)) || (ContentOptTags.Strong.includes("meta_description") && ["desc_miss", "desc_beyond", "desc_length"].includes(item)) || ContentOptTags.Strong.includes(item)) ? 1 : 2;

                let ContentOptArr = {
                    tag: item,
                    title: ContentOptCompare.title[item],
                    desc: num > 0 ? ContentOptCompare.desc.wrong[item] : ContentOptCompare.desc.right[item],
                    subdesc: ContentOptCompare.subdesc[item],
                    nums: num,
                    state: num === 0 ? true : false,
                    degree: degree,
                    children: ContentOptimizationObj[item],
                    childShow: childShow,
                    isIgnore: typeof ContentOptimizationObj[item]['content'] !== 'object' ? false : Object.keys(ContentOptimizationObj[item]['content']).includes('ignore') ? ContentOptimizationObj[item]['content'] : false,
                    isShowNumDesc: numTag.includes(item) && num > 0 ? true : false,
                    noShowSonTier: Boolean(noSonTier.includes(item)),
                    primaryBtn: Boolean(descAndBtn.includes(item)),
                }

                return ContentOptArr
            })
            checkItem['Content Optimization']['status'] = (ContentOptimizationList.filter(item => item.degree === 1 && item.nums > 0)).length > 0 ? 1 : (ContentOptimizationList.filter(item => item.degree === 2 && item.nums > 0)).length > 0 ? 2 : true;
            checkItem['Content Optimization']['nums'] = this.getSums(ContentOptimizationList, 'nums') - data.contentOptimization.ignore;
            checkItem['Content Optimization']['issue'] = this.sortList(ContentOptimizationList, 'contentOpt', tagData);
            checkItem['Content Optimization']['subtitle'] = this.getSums(ContentOptimizationList, 'nums') !== 0 ? (this.getSums(ContentOptimizationList, 'nums') > 1 ? t("Notices detected") : t("Notice detected")) : t("All Content Optimization items are set correctly");
        } else {
            checkItem['Content Optimization']['status'] = true;
            checkItem['Content Optimization']['issue'] = [];
            checkItem['Content Optimization']['subtitle'] = t("Detecting") + '...';
        }

        // GEO项 ------------------ 问题 
        let GeoObj = {}, GeoList = [];
        Object.keys(data.geo).forEach(item => {
            if (data.geo['state'] === 1) {
                if (item !== 'state' && item !== 'ignore') {
                    if (item === 'json_ld') {
                        // 数值判断开关
                        let searchAppContent = cloneDeep(data.geo[item]['content']);
                        Object.keys(searchAppContent).forEach(t => {
                            searchAppContent[t] = searchAppContent[t] === 0 ? 1 : 0;
                        })
                        GeoObj['json_ld'] = searchAppContent;
                    } else {
                        GeoObj[item] = data.geo[item];
                    }
                }
            }
        })
        if (Object.keys(GeoObj).length > 0) {
            GeoList = Object.keys(GeoObj).map(item => {
                let num = 0, childShow = true;
                if (item === 'llms_txt') {
                    num = GeoObj[item]['content']['status'] === 1 ? 0 : 1;
                    childShow = false;
                } else {
                    Object.values(GeoObj[item]).forEach(n => {
                        num += Number(n);
                    })
                }
                let GeoArr = {
                    tag: item,
                    title: GEOCompare.title[item],
                    desc: num > 0 ? GEOCompare.desc.wrong[item] : GEOCompare.desc.right[item],
                    subdesc: GEOCompare.subdesc[item],
                    nums: num,
                    state: num === 0 ? true : false,
                    degree: GEOTags.Strong.includes(item) ? 1 : 2,
                    children: item === 'llms_txt' ? {} : GeoObj[item],
                    childShow: childShow,
                    isIgnore: item === 'llms_txt' ? (Object.keys(GeoObj[item]['content']).includes('ignore') ? GeoObj[item]['content'] : false) : false,
                    isShowNumDesc: numTag.includes(item) && num > 0 ? true : false,
                    noShowSonTier: Boolean(noSonTier.includes(item)),
                    primaryBtn: Boolean(descAndBtn.includes(item)),
                }

                return GeoArr
            })
            checkItem['GEO']['status'] = (GeoList.filter(item => item.degree === 1 && item.nums > 0)).length > 0 ? 1 : (GeoList.filter(item => item.degree === 2 && item.nums > 0)).length > 0 ? 2 : true;
            checkItem['GEO']['nums'] = this.getSums(GeoList, 'nums') - data.geo.ignore;
            checkItem['GEO']['issue'] = this.sortList(GeoList, 'GEO', tagData);
            checkItem['GEO']['subtitle'] = this.getSums(GeoList, 'nums') !== 0 ? (this.getSums(GeoList, 'nums') > 1 ? t("Notices detected") : t("Notice detected")) : t("All GEO items are set correctly");

        } else {
            checkItem['GEO']['status'] = true;
            checkItem['GEO']['issue'] = [];
            checkItem['GEO']['subtitle'] = t("Detecting") + '...';
        }

        // Technical SEO项 ------------------ 问题
        let TechnicalSEOObj = {}, TechnicalSEOList = [];
        Object.keys(data.technicalSEO).forEach(item => {
            if (data.technicalSEO['state'] === 1) {
                if (item !== 'state' && item !== 'ignore') {
                    TechnicalSEOObj[item] = data.technicalSEO[item];
                }
            }
        })
        if (Object.keys(TechnicalSEOObj).length > 0) {
            TechnicalSEOList = Object.keys(TechnicalSEOObj).map(item => {
                let num = ['html_sitemap'].includes(item) ? (TechnicalSEOObj[item]['content']['status'] === 1 ? 0 : 1) :
                    item === 'sitemap' ? (TechnicalSEOObj[item]['content'] === 1 ? 0 : 1) :
                        item === 'broken_links' ? TechnicalSEOObj[item]['content'] :
                            item === 'exchange_backlinks' ? (TechnicalSEOObj[item]['content']?.count || 0) :
                                item === 'underscores_in_the_urls' ? this.getSums(Object.values(TechnicalSEOObj['underscores_in_the_urls']['content']), 'null') :
                                    item === 'mixed_content' ? (TechnicalSEOObj[item]['content'] > 0 ? 1 : 0) :
                                        TechnicalSEOObj[item]['content'] === 1 ? 0 : 1;
                return {
                    tag: item,
                    title: TechnicalSEOCompare.title[item],
                    desc: num > 0 ? TechnicalSEOCompare.desc.wrong[item] : TechnicalSEOCompare.desc.right[item],
                    subdesc: TechnicalSEOCompare.subdesc[item],
                    nums: num,
                    state: num === 0 ? true : false,
                    degree: TechnicalSEOTags.Strong.includes(item) ? 1 : 2,
                    children: item === 'underscores_in_the_urls' ? TechnicalSEOObj['underscores_in_the_urls']['content'] : {},
                    childShow: Boolean(item === 'underscores_in_the_urls'),
                    isIgnore: typeof TechnicalSEOObj[item]['content'] !== 'object' ? false : Object.keys(TechnicalSEOObj[item]['content']).includes('ignore') ? TechnicalSEOObj[item]['content'] : false,
                    isShowNumDesc: numTag.includes(item) && num > 0 ? true : false,
                    noShowSonTier: Boolean(noSonTier.includes(item)),
                    primaryBtn: Boolean(descAndBtn.includes(item)),
                }
            })
            checkItem['Technical SEO']['status'] = (TechnicalSEOList.filter(item => item.degree === 1 && item.nums > 0)).length > 0 ? 1 : (TechnicalSEOList.filter(item => item.degree === 2 && item.nums > 0)).length > 0 ? 2 : true;
            checkItem['Technical SEO']['nums'] = this.getSums(TechnicalSEOList, 'nums') - data.technicalSEO.ignore;
            checkItem['Technical SEO']['issue'] = this.sortList(TechnicalSEOList, 'technicalSEO', tagData);
            checkItem['Technical SEO']['subtitle'] = this.getSums(TechnicalSEOList, 'nums') !== 0 ? (this.getSums(TechnicalSEOList, 'nums') > 1 ? t("Notices detected") : t("Notice detected")) : t("All Technical SEO items are set correctly");
        } else {
            checkItem['Technical SEO']['status'] = true;
            checkItem['Technical SEO']['issue'] = [];
            checkItem['Technical SEO']['subtitle'] = t("Detecting") + '...';
        }

        return checkItem
    }

    // 计算长度
    getSums = (data, type = 'nums') => {
        let num = 0;
        if (type === 'nums') {
            data.forEach(item => {
                num += Number(item.nums);
            })
        }
        if (type === 'null') {
            data.forEach(item => {
                num += Number(item);
            })
        }
        return num;
    }

    // 排序列表
    sortList = (data, type, tagData) => {
        let list_strong = [], list_slight = [], extra = [];
        let tagAll = Boolean(tagData) ? tagData : this.state;
        let {
            SpeedOptTags,
            ContentOptTags,
            GEOTags,
            TechnicalSEOTags,
        } = tagAll;

        // Speed Optimization 父项
        if (type === 'speedOpt') {
            SpeedOptTags.Strong.forEach(item => {
                let list = data.filter(t => t.tag === item && t.nums !== 0)[0];
                if (Boolean(list)) {
                    list_strong.push(list)
                }
            })
            SpeedOptTags.Slight.forEach(item => {
                let list = data.filter(t => (t.tag === "amp" ? item.indexOf(t.tag) > -1 : t.tag === item) && t.nums !== 0)[0];
                if (Boolean(list)) {
                    if (list_slight.length === 0) {
                        list_slight.push(list);
                    } else {
                        list_slight.forEach(_list => {
                            if (_list.tag !== list.tag) {
                                list_slight.push(list);
                            }
                        })
                    }
                }
            })
            extra = data.filter(d => d.nums === 0);
        }

        // Content Optimization 父项
        if (type === 'contentOpt') {
            let strongTagNew = [], slightTagNew = [];
            ContentOptTags.Strong.forEach(item => {
                if (item === 'title_tag') {
                    strongTagNew.push(...["title_miss", "title_beyond", "title_length"]);
                } else if (item === 'meta_description') {
                    strongTagNew.push(...["desc_miss", "desc_beyond", "desc_length"]);
                } else {
                    strongTagNew.push(item);
                }
            })
            ContentOptTags.Slight.forEach(item => {
                if (item === 'title_tag') {
                    slightTagNew.push(...["title_miss", "title_beyond", "title_length"]);
                } else if (item === 'meta_description') {
                    slightTagNew.push(...["desc_miss", "desc_beyond", "desc_length"]);
                } else {
                    slightTagNew.push(item);
                }
            })
            strongTagNew.forEach(item => {
                let list = data.filter(t => t.tag === item && t.nums !== 0)[0];
                if (Boolean(list)) {
                    list_strong.push(list)
                }
            })
            slightTagNew.forEach(item => {
                let list = data.filter(t => t.tag === item && t.nums !== 0)[0];
                if (Boolean(list)) {
                    list_slight.push(list)
                }
            })
            extra = data.filter(d => d.nums === 0);
        }

        // GEO 父项
        if (type === 'GEO') {
            GEOTags.Strong.forEach(item => {
                let list = data.filter(t => t.tag === item && t.nums !== 0)[0];
                if (Boolean(list)) {
                    list_strong.push(list)
                }
            })
            GEOTags.Slight.forEach(item => {
                let list = data.filter(t => t.tag === item && t.nums !== 0)[0];
                if (Boolean(list)) {
                    list_slight.push(list)
                }
            })
            extra = data.filter(d => d.nums === 0);
        }

        // Technical SEO 父项
        if (type === 'technicalSEO') {
            TechnicalSEOTags.Strong.forEach(item => {
                let list = data.filter(t => t.tag === item && t.nums !== 0)[0];
                if (Boolean(list)) {
                    list_strong.push(list)
                }
            })
            TechnicalSEOTags.Slight.forEach(item => {
                let list = data.filter(t => t.tag === item && t.nums !== 0)[0];
                if (Boolean(list)) {
                    list_slight.push(list)
                }
            })
            extra = data.filter(d => d.tag !== "encoding" && d.tag !== "exchange_backlinks" && d.nums === 0);
        }

        return [...list_strong, ...list_slight, ...extra]
    }

    // 获取网站同步状态
    getWebsiteSyncStatus = async () => {
        const res = await reqGetWebsiteSyncStatus();
        if (res.ack === 1) {
            if (res.data.ai_analysis !== 2) {
                if (AnalysisStatusArr.length === 0) {
                    // 还未检测完成， 继续轮询
                    let timer = setInterval(() => {
                        this.getWebsiteSyncStatus();
                    }, 5000)
                    AnalysisStatusArr.push(timer)
                }
            } else {
                this.setState({
                    completedVal: 100,
                    stepIndex: 1,
                    stepChildIndex: 0,
                }, () => {
                    // 请求数据
                    this.getAnalyzeBusiness();
                    this.clearAnalysisStatusArr();
                    this.requestStateSet('in_business', 1);
                })
            }
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取分析业务数据
    getAnalyzeBusiness = async () => {
        const res = await reqGetAnalyzeBusiness();
        if (res.ack === 1) {
            let _that = res.data;
            this.setState({
                BrandNameValue: _that.brand_name,
                PrimaryProduct: _that.primary_products,
                KeyProductAttributes: _that.key_attributes,
                TargetPersona: _that.target_audience,
                aiLang: _that.content_language,
                audience_location: _that.audience_location,
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 清除倒计时定时器
    clearSEOCheckArr = () => {
        SEOCheckArr.map(timer => {
            clearInterval(timer);
            SEOCheckArr.pop();
            return false;
        })
    }

    // 清除网站同步状态定时器
    clearAnalysisStatusArr = () => {
        AnalysisStatusArr.map(timer => {
            clearInterval(timer);
            AnalysisStatusArr.pop();
            return false;
        })
    }

    //改版 语言选择器
    handleImportedAction = (val) => {
        store.dispatch(setLangState(false)); // 重置语言状态
        this.setState({
            languageActive: false,
            LanguageVal: val,
        }, async () => {
            window.language = val;
            this.props.changeLanguageStatus(val); //缓存全局状态
            const params = {
                Language: val,
            };
            await reqUpdateLanguage(params);
        })
    }

    //关闭 or 打开
    toggleActive = (languageActiveVal) => {
        this.setState({
            languageActive: languageActiveVal
        })
    }

    //语言转换
    LanguageChangeTransformation = (val) => {
        switch (val) {
            case 'cs': return 'Čeština';
            case 'da': return 'Dansk';
            case 'ge': return 'Deutsch';
            case 'en': return 'English';
            case 'sp': return 'Español';
            case 'fr': return 'Française';
            case 'it': return 'Italian';
            case 'in': return 'India';
            case 'dut': return 'Nederlands';
            case 'nb': return 'Norsk (bokmål)';
            case 'pl': return 'Polski';
            case 'pt_BR': return 'Português (Brasil)';
            case 'pt': return 'Português (Portugal)';
            case 'fi': return 'Suomi';
            case 'sv': return 'Svenska';
            case 'tr': return 'Türkçe';
            case 'th': return 'ภาษาไทย';
            case 'ja': return '日本語';
            case 'zh_hant': return '中文繁体';
            case 'zh': return '中文简体';
            case 'ko': return '한국어';
            default: return 'English';
        }
    };

    // 鼠标进入 - 修复SEO问题
    handleFixMouseAction = (val) => {
        this.setState({
            fixShow: val,
        })
    }

    // 鼠标进入 - 创建内容排名
    handleRanksMouseAction = (val) => {
        this.setState({
            ranksShow: val,
        })
    }

    // 选择模式
    handleModeSelect = (val) => {
        this.setState({
            modeItem: val,
        })
    }

    // 跳转步骤
    handleStepJump = (val) => {
        if (val === 0) {
            this.setState({
                stepIndex: val,
                completedVal: 0,
                stepChildIndex: 0,
                PrimaryProduct: [],
                KeyProductAttributes: [],
                TargetPersona: [],
                aiLang: 'en',
                audience_location: '',
                BrandNameValue: '',
            })
        } else {
            this.handleUpdGuideState(this.state.modeItem, true);
        }
    }

    // 子步骤跳转
    stepChildJump = () => {
        this.setState({
            stepChildIndex: 1,
            completedVal: 0,
        }, () => {
            // 启动假进度
            this.startFakeProgress();
            // 执行轮询
            let { modeItem } = this.state;
            if (modeItem === 0) {
                this.getSeoCheckerData();
            } else {
                this.getWebsiteSyncStatus();
            }
        })

    }

    // 启动假进度
    startFakeProgress = () => {
        this.clearFakeTimers();
        fakeSteps.forEach(step => {
            const timerId = setTimeout(() => {
                // 如果已经完成，就不要再改值
                if (this.state.completedVal < 100) {
                    this.setState({ completedVal: step.value });
                }
            }, step.delay);

            this.fakeTimers.push(timerId);
        });
    };

    // 输入框变化
    handleChangeInput = (val, type) => {
        this.setState({
            [type]: val,
            fristChange: false,
        }, () => {
            if (type === 'countryValue') {
                this.changeCountryData(val);
            }
        })
    }


    // 选择ai输出语言
    handleSelectAiLanguage = (val) => {
        this.setState({
            aiLang: val,
            fristChange: false,
        })
    }

    // 选择国家
    togglePopSelect = (type) => {
        this.setState({
            [type]: !this.state[type],
        })
    }

    // 选中国家
    selectCountryData = (data) => {
        this.setState({
            currents: data,
            nationState: false,
            locationId: data.id,
            fristChange: false,
        })
        try {
            sessionStorage.setItem('nationData', JSON.stringify(data));
        } catch (e) { }
        this.resetCountryData();
    }

    // 重置数据
    resetCountryData = () => {
        let { countryAll, nationState } = this.state;
        if (nationState) {
            let oData = countryAll.slice(0, 20);
            let lens = countryAll.length;
            this.setState({
                cpage: 1,
                csize: 20,
                countryValue: '',
                countryView: oData,
                countryLens: lens,
            })
        }
    }

    // 获取更多国家
    getMoreCountry = () => {
        let { countryAll, countryValue, cpage, csize } = this.state;
        if (countryValue) {
            let searchVal = countryValue.toLowerCase();
            let newData = countryAll.filter(item => (item.abb.toLowerCase()).indexOf(searchVal) > -1 || (item.name.toLowerCase()).indexOf(searchVal) > -1);
            let firstArr = [];
            let lastArr = [];
            newData.forEach(item => {
                if ((item.name.toLowerCase()).indexOf(searchVal) === 0) {
                    firstArr.push(item);
                } else {
                    lastArr.push(item);
                }
            })
            newData = [...firstArr, ...lastArr];
            this.setState({
                countryView: newData.slice(0, (cpage + 1) * csize),
                countryLens: newData.length,
                cpage: cpage + 1,
            })
        } else {
            this.setState({
                countryView: countryAll.slice(0, (cpage + 1) * csize),
                cpage: cpage + 1,
            })
        }
    }

    // 国家数据格式化
    changeCountryData = (val) => {
        let { countryAll } = this.state;
        let searchVal = val.toLowerCase();
        let newData = countryAll.filter(item => (item.abb.toLowerCase()).indexOf(searchVal) > -1 || (item.name.toLowerCase()).indexOf(searchVal) > -1);
        let firstArr = [];
        let lastArr = [];
        newData.forEach(item => {
            if ((item.name.toLowerCase()).indexOf(searchVal) === 0) {
                firstArr.push(item);
            } else {
                lastArr.push(item);
            }
        })
        newData = [...firstArr, ...lastArr];
        this.setState({
            countryView: newData.slice(0, 20),
            countryLens: newData.length,
            cpage: 1,
            csize: 20,
        })
    }

    // 跳转步骤
    handleModeJump = () => {
        // 更新缓存
        let data = cloneDeep(this.props.public.publicInit?.guide_steps || []);
        if (data?.length > 0) {
            let selectModelItem = data.find(i => i.step_key === "select_model");
            if (selectModelItem) {
                selectModelItem.is_completed = 1;
                selectModelItem.user_action = `select: ${this.state.selectType}`;
                store.dispatch(setSaveGuideSwitchData(data));
            }
        }

        // posthog埋点 完成
        this.cwreportGuideComplete();

        // 延迟跳转
        setTimeout(() => {
            let { modeItem } = this.state;
            utils.routeJump(this, modeItem === 0 ? "/website-check" : "/content-seo/keyword-content-planner", null, { isShowFloatingInfo: modeItem !== 0 });
        }, 500)
    }

    // 更新引导状态
    handleUpdGuideState = (type, isSkip = false) => {
        this.setState({
            updGuideLoading: true,
        }, async () => {
            this.updAnalyzeBusiness();
            const params = {
                step_key: "select_model",
                position: "onboarding_page",
                action: {
                    select: type === 0 ? "model_1" : "model_2"
                }
            }
            const res = await reqUpdGuideSteps(params);
            if (res.ack === 1) {
                this.setState({
                    stepIndex: 2,
                    stepChildIndex: 0,
                    completedVal: 0,
                    selectType: type === 0 ? "model_1" : "model_2"
                }, () => {
                    if (isSkip) {
                        this.cwreportGuideSkip();
                    }
                })
            } else {
                this.setState({
                    updGuideLoading: false,
                })
            }
        })
    }

    // 更新业务数据
    updAnalyzeBusiness = async () => {
        let { BrandNameValue, aiLang, currents, PrimaryProduct, KeyProductAttributes, TargetPersona } = this.state;
        const params = {
            brand_name: BrandNameValue,
            content_language: aiLang,
            audience_location: currents.abb,
            primary_products: PrimaryProduct,
            key_attributes: KeyProductAttributes,
            target_audience: TargetPersona,
        }
        const res = await reqUpdAnalyzeBusiness(params);
        if (res.ack === 1) {
            this.setState({
                updAnalyzeBusinessLoading: false,
            })
        } else {
            this.setState({
                updAnalyzeBusinessLoading: false,
            })
        }
    }

    // 调起客服
    handleContactService = () => {
        try {
            showNewMessage();
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 发送请求
    requestStateSet = async (type, state) => {
        const params = {
            name: `${type}`,
            st: Number(state),
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data);
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
            this.props.setSwitchData(data);
        } else {
            // this.props.toggleToast(t("Try again later"), true);
        }

        return res;
    }

    // 设置tag数据
    setChangeTagsData = (val, type) => {
        let value = val.map(item => item.value);
        this.setState({
            [type]: value,
            fristChange: false,
        })
    }

    // 清除假进度
    clearFakeTimers = () => {
        this.fakeTimers.forEach(timer => clearTimeout(timer));
        this.fakeTimers = [];
    };

    render() {
        const {
            stepIndex,
            stepChildIndex,
            LanguageVal,
            languageActive,
            isComboUser,
            modeItem,
            fixShow,
            ranksShow,
            userName,
            completedVal,
            BrandNameValue,
            aiLang,
            currents,
            countryValue,
            countryView,
            countryLens,
            nationState,
            SEOScore,
            updGuideLoading,
            loadingPage,
            isJump,
            PrimaryProduct,
            KeyProductAttributes,
            TargetPersona,
            fristChange,
            // issuesNum,
            CriticalIssueNum,
            ImproveIssueNum,
            GoodResIssueNum,

        } = this.state;

        // 语言选择器
        const newLangArr = AiLanguageArr;

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 语言选择器
        const activator = (
            <div className="TimeSelectButton">
                <Button onClick={() => this.toggleActive(!languageActive)} disclosure="select" >
                    <Icon source={LanguageIcon} />
                    <p>{this.LanguageChangeTransformation(LanguageVal)}</p>
                </Button>
            </div>
        );
        const LanguageSelect = <Popover
            active={languageActive}
            activator={activator}
            onClose={() => this.toggleActive(!languageActive)}
        >
            <ActionList
                actionRole="languageitem"
                items={[
                    {
                        active: LanguageVal === 'cs',
                        content: "Čeština",
                        onAction: () => this.handleImportedAction('cs'),
                    },
                    {
                        active: LanguageVal === 'da',
                        content: "Dansk",
                        onAction: () => this.handleImportedAction('da'),
                    },
                    {
                        active: LanguageVal === 'ge',
                        content: "Deutsch",
                        onAction: () => this.handleImportedAction('ge'),
                    },
                    {
                        active: LanguageVal === 'en',
                        content: "English",
                        onAction: () => this.handleImportedAction('en'),
                    },
                    {
                        active: LanguageVal === 'sp',
                        content: "Español",
                        onAction: () => this.handleImportedAction('sp'),
                    },
                    {
                        active: LanguageVal === 'fr',
                        content: "Française",
                        onAction: () => this.handleImportedAction('fr'),
                    },
                    {
                        active: LanguageVal === 'it',
                        content: "Italian",
                        onAction: () => this.handleImportedAction('it'),
                    },
                    {
                        active: LanguageVal === 'in',
                        content: "India",
                        onAction: () => this.handleImportedAction('in'),
                    },
                    {
                        active: LanguageVal === 'dut',
                        content: "Nederlands",
                        onAction: () => this.handleImportedAction('dut'),
                    },
                    {
                        active: LanguageVal === 'nb',
                        content: "Norsk (bokmål)",
                        onAction: () => this.handleImportedAction('nb'),
                    },
                    {
                        active: LanguageVal === 'pl',
                        content: "Polski",
                        onAction: () => this.handleImportedAction('pl'),
                    },
                    {
                        active: LanguageVal === 'pt_BR',
                        content: "Português (Brasil)",
                        onAction: () => this.handleImportedAction('pt_BR'),
                    },
                    {
                        active: LanguageVal === 'pt',
                        content: "Português (Portugal)",
                        onAction: () => this.handleImportedAction('pt'),
                    },
                    {
                        active: LanguageVal === 'fi',
                        content: "Suomi",
                        onAction: () => this.handleImportedAction('fi'),
                    },
                    {
                        active: LanguageVal === 'sv',
                        content: "Svenska",
                        onAction: () => this.handleImportedAction('sv'),
                    },
                    {
                        active: LanguageVal === 'tr',
                        content: "Türkçe",
                        onAction: () => this.handleImportedAction('tr'),
                    },
                    {
                        active: LanguageVal === 'th',
                        content: "ภาษาไทย",
                        onAction: () => this.handleImportedAction('th'),
                    },
                    {
                        active: LanguageVal === 'ja',
                        content: "日本語",
                        onAction: () => this.handleImportedAction('ja'),
                    },
                    {
                        active: LanguageVal === 'zh_hant',
                        content: "中文繁体",
                        onAction: () => this.handleImportedAction('zh_hant'),
                    },
                    {
                        active: LanguageVal === 'zh',
                        content: "中文简体",
                        onAction: () => this.handleImportedAction('zh'),
                    },
                    {
                        active: LanguageVal === 'ko',
                        content: "한국어",
                        onAction: () => this.handleImportedAction('ko'),
                    }
                ]}
            />
        </Popover>

        // 选择模式步骤 - 1
        const selectModeStep = <div className='guide_cards'>
            {
                stepChildIndex === 0 ? <div className='guide_cards_content parent_step'>
                    {/* 第一个卡片 - Identify And Fix SEO Issues */}
                    <div className={`guide_card_item ${modeItem === 0 ? 'item_bg' : ''}`} onClick={() => this.handleModeSelect(0)}>
                        <Card padding={0}>
                            <div
                                className='guide_card_media'
                                onMouseEnter={() => this.handleFixMouseAction(1)}
                                onMouseLeave={() => this.handleFixMouseAction(0)}
                            >
                                <img src={`${fixShow === 0 ? '/imgs/user_guide/if_seo_1.png' : '/imgs/user_guide/if_seo_2.png'}?v=260105`} alt='' />
                            </div>
                            <div className='guide_card_content'>
                                <BlockStack gap={200}>
                                    <Text variant="bodyLg" fontWeight="semibold" as="h3">{t("Identify And Fix SEO Issues")}</Text>
                                    <Text variant="bodySm" as="p">{t("Fix technical and on-page SEO problems to improve your website rankings.")}</Text>
                                </BlockStack>
                            </div>
                        </Card>
                    </div>

                    {/* 第二个卡片 - Create Content That Ranks */}
                    <div className={`guide_card_item ${modeItem === 1 ? 'item_bg' : ''}`} onClick={() => this.handleModeSelect(1)}>
                        <Card padding={0}>
                            <div
                                className='guide_card_media'
                                onMouseEnter={() => this.handleRanksMouseAction(1)}
                                onMouseLeave={() => this.handleRanksMouseAction(0)}
                            >
                                <img src={`${ranksShow === 0 ? '/imgs/user_guide/cc_ranks_1.png' : '/imgs/user_guide/cc_ranks_2.png'}?v=260105`} alt='' />
                            </div>
                            <div className='guide_card_content'>
                                <BlockStack gap={200}>
                                    <Text variant="bodyLg" fontWeight="semibold" as="h3">{t("Create Content That Ranks")}</Text>
                                    <Text variant="bodySm" as="p">{t("Build a winning SEO strategy in minutes and turn it into high-ranking blog posts with SEOWILL AI.")}</Text>
                                </BlockStack>
                            </div>
                        </Card>
                    </div>
                </div> : <div className='guide_cards_content child_step'>
                    <BlockStack gap={1600}>
                        {
                            modeItem === 0 ? <div className='animate_analyze scan_analyze'>
                                <div className="scanner-bar"></div>
                                <img src='/imgs/user_guide/fix-1.png' alt='' />
                            </div> : <div className='animate_analyze'>
                                <img className='ranks_first' src='/imgs/user_guide/ranks-1.png' alt='' />
                                <img className='ranks_sec' src='/imgs/user_guide/ranks-2.png' alt='' />
                            </div>
                        }

                        <div className='progress_bar_item'>
                            <ProgressBar progress={completedVal} size='small' tone='primary' />
                            <p>{t("Completed")} <span style={{ color: '#616161' }}>{completedVal}%</span></p>
                            <br />
                            <div className='progress_bar_item_btn'>
                                <Button loading={updGuideLoading} onClick={() => this.handleStepJump(2)}>{t("Skip")}</Button>
                            </div>
                        </div>
                    </BlockStack>
                </div>
            }
        </div>

        // 选择模式步骤 - 2
        const contentStep = modeItem === 0 ? <div className='content_step_container fix_audit_step'>
            <BlockStack gap={400}>
                {/* 标题区域 */}
                <div className='content_step_header'>
                    <Text variant="heading2xl" as="h2" alignment="center">
                        {t("We found")} <span style={{ color: 'var(--color-primary)' }}>{CriticalIssueNum + ImproveIssueNum}</span> {t("SEO issues affecting your website rankings")}
                    </Text>
                    <Text variant="bodyLg" as="p" alignment="center" tone="subdued">
                        {t("Here's your website SEO health check. Review and fix the issues that matter to your rankings.")}
                    </Text>
                </div>

                {/* 主要内容卡片 */}
                <div className='content_step_card'>
                    <BlockStack gap={1200}>
                        {/* 仪表盘区域 */}
                        <div className='content_step_gauge'>
                            <div className='content_step_gauge_item'>
                                <CircularGauge score={SEOScore} />
                                <Text variant="heading2xl" as="h2">
                                    <span style={{ color: SEOScore <= 60 ? '#D33430' : SEOScore > 60 && SEOScore <= 85 ? '#F1930F' : '#27AE60' }}>{SEOScore}</span>
                                </Text>
                            </div>
                            <Text variant="headingLg" as="h3" alignment="center">
                                {t("Your Website SEO Health Score")}
                            </Text>
                        </div>

                        {/* 统计卡片区域 */}
                        <div className='content_step_stats'>
                            <div className='content_step_stat_item'>
                                <div className='stat_item_content'>
                                    <div className='stat_item_icon'>
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 9C15.6214 9.00001 16.125 9.5037 16.125 10.125L16.1249 15.375C16.1249 15.9963 15.6212 16.5 14.9999 16.5C14.3786 16.5 13.8749 15.9963 13.8749 15.375L13.875 10.125C13.875 9.50366 14.3787 8.99999 15 9Z" fill="#EF4D2F" />
                                            <path d="M16.5 19.5C16.5 20.3284 15.8284 21 15 21C14.1716 21 13.5 20.3284 13.5 19.5C13.5 18.6716 14.1716 18 15 18C15.8284 18 16.5 18.6716 16.5 19.5Z" fill="#EF4D2F" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M16.8562 4.76494C15.831 3.73981 14.169 3.73981 13.1439 4.76494L4.76518 13.1436C3.74005 14.1687 3.74006 15.8308 4.76518 16.8559L13.1439 25.2346C14.169 26.2597 15.831 26.2597 16.8562 25.2346L25.2349 16.8559C26.26 15.8308 26.26 14.1687 25.2349 13.1436L16.8562 4.76494ZM14.7349 6.35593C14.8813 6.20948 15.1187 6.20948 15.2652 6.35593L23.6439 14.7346C23.7903 14.8811 23.7903 15.1185 23.6439 15.2649L15.2652 23.6436C15.1187 23.7901 14.8813 23.7901 14.7349 23.6436L6.35617 15.2649C6.20973 15.1185 6.20973 14.8811 6.35617 14.7346L14.7349 6.35593Z" fill="#EF4D2F" />
                                        </svg>
                                    </div>
                                    <Text variant="bodySm" fontWeight="semibold" as="p">
                                        {t("{{v1}} Critical issues", CriticalIssueNum)}
                                    </Text>
                                </div>
                            </div>
                            <div className='content_step_stat_item'>
                                <div className='stat_item_content'>
                                    <div className='stat_item_icon'>
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 9C15.6213 9.00001 16.125 9.5037 16.125 10.125L16.1249 15.375C16.1249 15.9963 15.6212 16.5 14.9999 16.5C14.3786 16.5 13.8749 15.9963 13.8749 15.375L13.875 10.125C13.875 9.50366 14.3787 8.99999 15 9Z" fill="#E5A500" />
                                            <path d="M16.5 19.5C16.5 20.3284 15.8284 21 15 21C14.1716 21 13.5 20.3284 13.5 19.5C13.5 18.6716 14.1716 18 15 18C15.8284 18 16.5 18.6716 16.5 19.5Z" fill="#E5A500" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M25.5 15C25.5 20.799 20.799 25.5 15 25.5C9.20101 25.5 4.5 20.799 4.5 15C4.5 9.20101 9.20101 4.5 15 4.5C20.799 4.5 25.5 9.20101 25.5 15ZM23.25 15C23.25 19.5563 19.5563 23.25 15 23.25C10.4437 23.25 6.75 19.5563 6.75 15C6.75 10.4437 10.4437 6.75 15 6.75C19.5563 6.75 23.25 10.4437 23.25 15Z" fill="#E5A500" />
                                        </svg>
                                    </div>
                                    <Text variant="bodySm" fontWeight="semibold" as="p">
                                        {t("{{v1}} Needs improvement", ImproveIssueNum)}
                                    </Text>
                                </div>
                            </div>
                            <div className='content_step_stat_item'>
                                <div className='stat_item_content'>
                                    <div className='stat_item_icon'>
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.9205 13.5455C20.3598 13.1062 20.3598 12.3938 19.9205 11.9545C19.4812 11.5152 18.7688 11.5152 18.3295 11.9545L13.875 16.409L12.0455 14.5795C11.6062 14.1402 10.8938 14.1402 10.4545 14.5795C10.0152 15.0188 10.0152 15.7312 10.4545 16.1705L13.0795 18.7955C13.5188 19.2348 14.2312 19.2348 14.6705 18.7955L19.9205 13.5455Z" fill="#29845A" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M25.5 15C25.5 20.799 20.799 25.5 15 25.5C9.20101 25.5 4.5 20.799 4.5 15C4.5 9.20101 9.20101 4.5 15 4.5C20.799 4.5 25.5 9.20101 25.5 15ZM23.25 15C23.25 19.5563 19.5563 23.25 15 23.25C10.4437 23.25 6.75 19.5563 6.75 15C6.75 10.4437 10.4437 6.75 15 6.75C19.5563 6.75 23.25 10.4437 23.25 15Z" fill="#29845A" />
                                        </svg>
                                    </div>
                                    <Text variant="bodySm" fontWeight="semibold" as="p">
                                        {t("{{v1}} Good results", GoodResIssueNum)}
                                    </Text>
                                </div>
                            </div>
                        </div>
                    </BlockStack>
                </div>
            </BlockStack>
        </div> : <div className={`content_step_container business_step ${fristChange ? 'purple_color_input' : ''}`}>
            <BlockStack gap={800}>
                {/* 标题区域 */}
                <div className='content_step_header'>
                    <Text variant="heading2xl" as="h2">
                        {t("Here's what we've learned about your business so far.")}
                    </Text>
                    <Text variant="bodyLg" as="p" tone="subdued">
                        {t("This helps us recommend and generate content that fits your business and audience. You can review and edit any details if needed.")}
                    </Text>
                </div>

                <BlockStack gap={400}>
                    {/* 信息汇总 */}
                    <div className='business_step_info'>
                        <TextField
                            id="BrandNameValue"
                            label={t("Brand Name")}
                            value={BrandNameValue}
                            onChange={this.handleChangeInput}
                            autoComplete="off"
                            placeholder={t("Enter your brand name")}
                        />
                        <div className='audience_location'>
                            <div className='label_text'>
                                <label>{t("Audience location")}</label>
                            </div>
                            <Popover
                                active={nationState}
                                activator={
                                    <Button
                                        disclosure
                                        fullWidth
                                        textAlign='left'
                                        onClick={() => this.togglePopSelect('nationState')}
                                    // disabled={false}
                                    >
                                        <p className='nation_set' title={currents.abb}>
                                            <img src={currents.src} alt='' />
                                            <span>{currents.name}</span>
                                        </p>
                                    </Button>
                                }
                                autofocusTarget="first-node"
                                onClose={() => this.togglePopSelect('nationState')}
                            >
                                <div className='country_box'>
                                    <TextField
                                        id="countryValue"
                                        value={countryValue}
                                        onChange={this.handleChangeInput}
                                        autoComplete="off"
                                        placeholder={t("Search")}
                                        prefix={<Icon source={SearchIcon} />}
                                        clearButton
                                        onClearButtonClick={() => this.handleChangeInput("", "countryValue")}
                                    />
                                    {
                                        countryView.length > 0 ? <div className='countrys_all'>
                                            {
                                                countryView.map(item => {
                                                    return <p key={item.abb} title={item.abb} onClick={() => this.selectCountryData(item)}>
                                                        <img src={item.src} alt={item.abb} />
                                                        <span>{item.name}</span>
                                                    </p>
                                                })
                                            }
                                            {
                                                countryLens > 20 && <Button variant='plain' onClick={this.getMoreCountry}>{t("View more")}</Button>
                                            }
                                        </div> : <div style={{ margin: '15px 5px 5px' }}>{t("No data found")}</div>
                                    }
                                </div>
                            </Popover>
                        </div>
                        <Select
                            id="aiLang"
                            label={<div className='flex_layout' style={{ gap: '0.25rem' }}>
                                <span>{t("Content Language")}</span>
                            </div>}
                            options={newLangArr}
                            onChange={this.handleSelectAiLanguage}
                            value={aiLang}
                        // disabled={false}
                        />
                    </div>

                    <div className='business_product'>
                        <span className='b_tag_title'>{t("Primary Product")}</span>
                        <TagTextInput
                            id="PrimaryProduct"
                            SelectCurrentItem={PrimaryProduct}
                            setChangeTagsData={this.setChangeTagsData}
                        />
                    </div>
                    <div className='business_key_product_attributes'>
                        <span className='b_tag_title'>{t("Key Product Attributes")}</span>
                        <TagTextInput
                            id="KeyProductAttributes"
                            SelectCurrentItem={KeyProductAttributes}
                            setChangeTagsData={this.setChangeTagsData}
                        />
                    </div>
                    <div className='business_target_persona'>
                        <span className='b_tag_title'>{t("Target Audience")}</span>
                        <TagTextInput
                            id="TargetPersona"
                            SelectCurrentItem={TargetPersona}
                            setChangeTagsData={this.setChangeTagsData}
                        />
                    </div>
                </BlockStack>
            </BlockStack>
        </div>

        // 提示banner
        const chargeTipBanner = <div className='charge_tip_banner'>
            <Text variant="bodyMd" as="p" tone='subdued'>{t("Questions about billing?")}&nbsp;<Button variant='plain' onClick={this.handleContactService}>{t("Contact us")}</Button>&nbsp; - {t("we're happy to help.")}</Text>
        </div>

        // 选择模式步骤 - 3
        const resultStep = <div className='trial_block'>
            <UserTrialDicountModal
                operaType={1}
                language={LanguageVal}
                isComboUser={isComboUser}
                isModal={false}
                getPageDataRedux={this.props.getPageDataRedux}
                cioPlanDataSet={this.props.cioPlanDataSet}
                toggleToast={this.props.toggleToast}
                handleOpenCwComboModal={this.props.handleOpenCwComboModal}
                handleModeJump={this.handleModeJump}
                cwreportCustomBehavior={this.props.cwreportCustomBehavior}
                handleGetPlanSource={this.props.handleGetPlanSource}
            />
            {chargeTipBanner}
        </div>

        // 最终内容
        const pageContent = <div className='new_guide_main' style={{
            background: stepIndex === 1 ? 'linear-gradient(to left bottom, #e5eaff, #eaeefe, #fff, #fff, #fff)' : '#fff'
        }}>
            <title>SEOWILL - Guide</ title>

            <div className='new_guide_container'>
                {
                    stepIndex === 1 ? <span className='guide_bg_icon'>
                        <svg width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.5" d="M189.2 0C210.225 2.50726e-05 247.968 7.22532 268.499 27.9004C288.803 48.3467 299.317 77.1558 298.994 108.11C298.853 121.674 295.83 135.651 291.985 149.516C283.3 118.2 265.539 84.8438 238.745 57.8623C211.955 30.8839 180.592 11.0513 149.498 2.30371C92.6353 16.1657 49.839 77.1889 49.8389 149.516C49.8389 221.846 92.6391 282.87 149.506 296.729C180.598 287.978 211.96 264.612 238.749 237.637C265.545 210.655 283.306 180.836 291.991 149.52C295.913 163.661 298.932 177.577 298.999 190.924C299.149 220.526 288.631 247.331 268.503 267.599C246.413 289.842 207.889 299.035 182.191 299.035C179.856 299.035 161.174 299.035 149.492 296.736C141.449 298.693 133.856 299.032 125.33 299.032C56.5172 299.032 7.21898e-06 232.091 0 149.516C0.000140787 66.9403 56.5172 6.01581e-06 125.33 0C133.859 1.12868e-05 141.456 0.338368 149.503 2.29688C163.522 0.0996819 186.865 0 189.2 0Z" fill="url(#paint0_linear_7589_340704)" />
                            <defs>
                                <linearGradient id="paint0_linear_7589_340704" x1="247.699" y1="19.6395" x2="91.385" y2="299.001" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="white" />
                                    <stop offset="1" stopColor="white" stopOpacity="0.3" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </span> : null
                }

                {/* 主要内容区域 */}
                <div className='guide_main'>
                    <BlockStack gap={800}>
                        <div className='guide_main_content'>
                            <BlockStack gap={800}>
                                {/* 顶部语言选择 */}
                                {
                                    stepIndex === 0 && stepChildIndex === 0 ? <div className='guide_language_select'>{LanguageSelect}</div> : null
                                }

                                {/* 标题区域 */}
                                {
                                    stepIndex === 0 ? <div className='guide_title_section'>
                                        {
                                            stepChildIndex === 0 ? <>
                                                <Text variant="bodyMd" fontWeight="semibold" as="p">{t("Hello")} {userName}</Text>
                                                <Text variant="heading2xl" as="h1">{t("What would you like to get started?")}</Text>
                                            </> : <Text variant="heading2xl" as="h1">{t("Let's analyze your website...")}</Text>
                                        }
                                    </div> : null
                                }

                                {/* 卡片区域 */}
                                {
                                    stepIndex === 0 ? selectModeStep :
                                        stepIndex === 1 ? contentStep :
                                            stepIndex === 2 ? resultStep :
                                                null
                                }

                                {/* 底部按钮 */}
                                {
                                    stepChildIndex === 1 ? null :
                                        stepIndex === 0 ? <div className='guide_actions'>
                                            <ButtonGroup>
                                                <Button loading={updGuideLoading} onClick={() => this.handleStepJump(2)}>{t("Skip")}</Button>
                                                <Button disabled={updGuideLoading} variant="primary" onClick={this.stepChildJump}>{t("Continue")}</Button>
                                            </ButtonGroup>
                                        </div> :
                                            stepIndex === 1 ? <div className='guide_actions'>
                                                <ButtonGroup>
                                                    <Button onClick={() => this.handleStepJump(0)} disabled={updGuideLoading}>{t("Previous")}</Button>
                                                    {
                                                        modeItem === 0 ? <Button variant="primary" loading={updGuideLoading} onClick={() => this.handleUpdGuideState(0, false)}>{t("Fix Issues Now")}</Button> : <Button variant="primary" loading={updGuideLoading} onClick={() => this.handleUpdGuideState(1, false)}>{t("Continue")}</Button>
                                                    }
                                                </ButtonGroup>
                                            </div>
                                                : null
                                }
                            </BlockStack>
                        </div>
                        {/* 步骤栏 */}
                        <div className='guide_steps_line' style={{ opacity: stepIndex === 0 && stepChildIndex === 1 ? 0 : 1 }}>
                            {
                                [0, 1, 2].map((_, index) => (
                                    <span
                                        key={index}
                                        className={index === stepIndex ? 'active' : ''}
                                        style={{ width: index === stepIndex ? '48px' : '16px' }}
                                    ></span>
                                ))
                            }
                        </div>

                    </BlockStack>
                </div>
            </div>

            {/* 底部 */}
            {FooterHelpBox}

        </div>;

        return (loadingPage || isJump === 1) ? <SkeltonLoading /> : pageContent;
    }
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 缓存数据
    getSEOCheckDataRedux(data) {
        dispatch(setPageData(['SEOChecker', data]));
    },

    // 修改语言状态
    changeLanguageStatus(val) {
        dispatch(changeLanguageInfo(val));
    },
})

Settings = connect(
    mapStateToProps,
    mapDispatchToProps
)(Settings);

export default withRouter(Settings);